export enum UserRoles {
  Admin = "Admin",
  ReadOnly = "ReadOnly",
  Integration = "Integration",
  User = "User",
  Custom = "Custom",
}

export enum GailProductRoles {
  GailAgentUser = "GailAgentUser",
  GailGPTUser = "GailGPTUser",
  ReportUser = "ReportUser",
}

export enum RoleData {
  Dashboard = "dashboard",
  GPT = "gpt",
  Reporting = "reporting",
  Inbound = "inbound",
  Outbound = "outbound",
  Campaigns = "campaigns",
  Sequences = "sequences",
  RedialingRules = "redialingRules",
  Messaging = "messaging",
  Contacts = "contacts",
  ContactLists = "contactLists",
  UseCases = "useCases",
  Scripts = "scripts",
  Agent = "agent",
  Activity = "activity",
  Assistants = "assistants",
  Knowledge = "knowledge",
  Integrations = "integrations",
  Support = "support",
  Settings = "settings",
  Workflows = "workflows",
  Notifications = "notifications",
}

export enum Permissions {
  Create = "Create",
  Read = "Read",
  Update = "Update",
  Delete = "Delete",
}
